import React from 'react';
import ProductPage from '../components/ProductPage';
import { DALCOMM_VINTAGE_IMAGES } from '../data/dalcomm';

const DalcommVintageHeadsetPage = ({ onRequestDemo, onRequestQuote }) => {
  const productData = {
    productName: 'Vintage Aviation Headset',
    partNumber: 'DALCOMM-VINTAGE',
    tagline: 'Leave the Noise Behind, and Enjoy the Flight.',
    description:
      'Dalcomm Tech’s Vintage Pilot’s Headset is the standard model made better in every way. Familiar look, interchangeable cord, and every ear-seal / microphone / cable option you might actually need — configurable at checkout, upgradeable later. Four noise-blocking tiers, from lightweight passive attenuation up to Passive + Active + Bluetooth. Custom requests welcome — email sales@dalcommtech.com.',
    image: DALCOMM_VINTAGE_IMAGES[0],
    images: DALCOMM_VINTAGE_IMAGES,
    imageContain: true,
    features: [
      {
        title: 'Four Noise-Blocking Tiers',
        description:
          'Choose Passive, Passive + CEP military-grade ear plugs, Passive + Active ANR, or Passive + Active + Bluetooth. Same body, four levels of quiet.',
      },
      {
        title: '23 dB Passive Attenuation, Certified',
        description:
          'Independent-laboratory-certified 23 dB of passive mechanical noise blocking — the ear cup does the work before any electronics come into play.',
      },
      {
        title: 'CEP Ear Plugs Option (+29 dB)',
        description:
          'Adds military-grade Communications Ear Plugs (CEP USA) — 29 dB additional attenuation for jet engine testing, helipads, and other extreme-noise environments.',
      },
      {
        title: 'Active Noise Cancelling (ANR)',
        description:
          'Electronic ANR stacks on top of the 23 dB passive block — outside mic samples the noise, inverts the wave, and cancels it inside the cup.',
      },
      {
        title: 'Bluetooth (with ANR variant)',
        description:
          'Optional Bluetooth for wireless connection to phone or tablet — calls, weather briefs, checklists, and music.',
      },
      {
        title: 'Interchangeable Cord System',
        description:
          'Swap cord for the aircraft you are flying: fixed-wing twin plugs, helicopter (straight or coiled), 5-pin Airbus XLR, or USB Type-A for sim.',
      },
      {
        title: 'Protein-Leather Ear Seals (Default)',
        description:
          'Ships with protein leather seals — foam, gel, and gel + foam variants also available.',
      },
      {
        title: 'Full-Flex Mic Boom — 270° Rotation',
        description:
          'Boom rotates 270° for right- or left-handed use. Noise-cancelling amplified electret microphone.',
      },
      {
        title: '65-Month Warranty',
        description:
          'Standard 65-month manufacturer warranty.',
      },
    ],
    specifications: [
      { label: 'Noise-Blocking Tiers', value: 'Passive $345 · Passive + CEP $445 · Passive + Active (ANR) $545 · Passive + Active + Bluetooth $745' },
      { label: 'Passive Attenuation', value: '23 dB (independent-laboratory certified)' },
      { label: 'CEP Option', value: '+29 dB (CEP USA military-grade)' },
      { label: 'Microphone', value: 'Noise-cancelling amplified electret · 270° boom rotation' },
      { label: 'Connection Options', value: 'Twin plugs (fixed wing) · Helicopter (straight or coiled) · 5-pin Airbus XLR' },
      { label: '10% Off Second Cable', value: 'SBJ-1 / SBJ-2 / SBJ-15 / SBJ-12 (+$70) · SBJ-USB (+$116)' },
      { label: 'Ear Seals', value: 'Foam · Gel · Gel + Foam · Protein Leather (default)' },
      { label: 'Dimensions', value: '12 × 12 × 6 in (packaged)' },
      { label: 'Warranty', value: '65 months manufacturer warranty' },
      { label: 'Price Range', value: '$345 – $861 depending on configuration' },
    ],
    applications: [
      'GA and light-twin daily flying',
      'Rotary-wing operations',
      'Airbus 5-pin XLR aircraft',
      'Ramp and jet-engine-test-cell work (CEP tier)',
      'Long-leg IFR with ANR',
      'Bluetooth pairing for pre-flight briefings and music on the ground',
    ],
  };

  return <ProductPage {...productData} onRequestDemo={onRequestDemo} onRequestQuote={onRequestQuote} />;
};

export default DalcommVintageHeadsetPage;
